<template>
    <div class="main-container">
      <div class="left-part">
        <img src="@/assets/vuega_together.png" alt="Image" class="left-image">
      </div>
      <div class="right-part">
        <h1>Life at <span class="vuega">VUEGA</span></h1>
        <p>At Vuega, "we rise by lifting others". Our culture thrives on collaboration and mutual support, empowering each team member to grow and excel. Join us to innovate, inspire, and elevate one another in a dynamic, inclusive environment.</p>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'LifeAtVuega',
    components: {}
  }
  </script>
  
  <style scoped>
  .main-container {
    margin-top: 50px;
    width: 100%;
    height: 600px;
    display: flex;
    box-sizing: border-box;
    background-color: #e2e6eb;
  }
  
  .left-part {
    width: 50%; /* Half of the container width */
    height: 100%;
    display: flex;
    justify-content: center; /* Center the image horizontally */
    align-items: center; /* Center the image vertically */
    padding: 20px; /* Optional: add some padding */
    box-sizing: border-box;
  }
  
  .left-image {
    width: 550px;
    height: 460px;
    border-radius: 15px; /* Rounded corners */
    object-fit: cover; /* Ensure the image covers the area */
  }
  
  .right-part {
    width: 50%; /* Half of the container width */
    height: 100%;
    padding: 20px; /* Add padding around the content */
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center; /* Center content vertically */
  }
  
  h1 {
    font-family: "Montserrat", sans-serif;
    font-size: 36px;
    font-weight: bold;
    color: #333;
    margin: 0 0 20px; /* Margin around the heading */
  }
  
  .vuega {
    font-family: "Kanit", sans-serif;
  font-weight: bold;
  color: #333;
  font-size: 39px;
  margin: 0; /* Remove default margin to eliminate space between headings */
  text-align: left; /* Align text to the left */
  }
  
  p {
    font-family: "Montserrat", sans-serif;
    font-size: 18px;
    color: #555;
    line-height: 36px;
    margin: 0; /* Remove margin around the paragraph */
    padding-right: 200px;
  }
  </style>
  